<div class="timeRangeDiv">
  <glxy-form-field class="timeRangeSelector" [showLabel]="false" bottomSpacing="none">
    <glxy-label>{{ 'LEADERBOARD.TIME_RANGE' | translate }}</glxy-label>
    <mat-select (selectionChange)="setTimeRange($event.value)" [value]="timeRangeOptions[0]">
      <mat-option *ngFor="let option of timeRangeOptions" [value]="option">
        {{ option.name }}
      </mat-option>
    </mat-select>
  </glxy-form-field>
  <glxy-form-field class="custom-date" *ngIf="(showCustomDateSelector$$ | async) === true" bottomSpacing="none">
    <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-input [rangePicker]="picker">
      <input
        [formControl]="customRangeStart"
        matStartDate
        placeholder="{{ 'LEADERBOARD.CUSTOM_RANGE.START' | translate }}"
      />
      <input
        [formControl]="customRangeEnd"
        matEndDate
        placeholder="{{ 'LEADERBOARD.CUSTOM_RANGE.END' | translate }}"
        (dateChange)="triggerCustomRangeChanged()"
      />
    </mat-date-range-input>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </glxy-form-field>
</div>
